import { produce } from 'immer';

import { NON_US_LOCATIONS_ACTION_TYPE } from '../actions';

const initialState = [];

const nonUSLocationsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case NON_US_LOCATIONS_ACTION_TYPE.GET_LOCATIONS:
        return payload || state;

      default:
        return state;
    }
  });

export default nonUSLocationsReducer;
